import prismicDOM from 'prismic-dom';
import { store } from '../store/store.js'

const Elements = prismicDOM.RichText.Elements;

export default function (type, element, content, children) {
  // El código span que se pondrá a los elementos con la etiqueta "glosario"
  var span = '<span class="tooltip" style="border-bottom: 1px dotted black; cursor: pointer"> '
  // Regex para eliminar espacios al principio o al final del contenido con la etiqueta glosario
  var sinEspacios = new RegExp(/^\s|\s$/)
  // si el rich content tiene la etiqueta glosario
  if (type === Elements.label && element.data.label == "glosario" ) {
    // pongale la variable span de ariba y join to it el otra contenido entre span que concuerde con el contenido guardado en Glosas de la Store
      return `${span} ${children.join('')} <span class="tooltiptext"> ${store.state.glosas[content.toLowerCase().replace(sinEspacios, '')]} </span></span>`;
  }
  // Return null to stick with the default behavior for everything else
  return null;
}